import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { finalize, Observable, of } from 'rxjs';
import { AppAuthServiceService } from '@core';
import { AdminService } from '@core';
import { SpinnerService } from '@core';
import { SystemStatus } from '@shared';

@Component({
    selector: 'ups-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    standalone: false
})
export class NavbarComponent implements OnInit {
  @Input() casesBtn: boolean = true;
  @Input() preferencesBtn: boolean = true;
  @Input() admintBtn: boolean = true;
  @Input() userName: string | undefined = '';

  public isLoggedIn: boolean = false;
  public isAdmin: boolean = false;
  public systemStatus$: Observable<Partial<SystemStatus>> = of({});

  constructor(
    private appAuthService: AppAuthServiceService,
    private router: Router,
    private adminService: AdminService,
    private spinnerService: SpinnerService
  ) {}

  ngOnInit(): void {
    this.appAuthService.isLoggedIn.subscribe((value) => (this.isLoggedIn = value));
    this.appAuthService.isAdmin.subscribe((value) => (this.isAdmin = value));
    this.userName = this.appAuthService.account.name;
    this.checkSystemStatus();
  }

  private checkSystemStatus(): void {
    this.systemStatus$ = this.adminService.currentSystemStatus;
  }

  public logout(): void {
    this.appAuthService.logout();
  }

  public goToCreateCase(): void {
    this.spinnerService.show();
    this.adminService
      .checkSystemStatus()
      .pipe(finalize(() => this.spinnerService.hide()))
      .subscribe((systemStatus) => this.router.navigate([`/${!systemStatus.enabled ? 'home' : 'case'}`]));
  }
}
